import { useRouter } from 'vue-router';
import { HANDLING_ITEM_SCAN_PATTERN, OFFER_RECEIPT_SCAN_PATTERN } from '../../constants';
import { useScanEvents } from './useScanEvents';

export const useGlobalScanEvents = () => {
  const router = useRouter();

  useScanEvents(
    [
      {
        priority: -1,
        regex: OFFER_RECEIPT_SCAN_PATTERN,
        handler: (value: string) => {
          const [, offerId = ''] = value.match(OFFER_RECEIPT_SCAN_PATTERN) || [];

          router.push({
            name: 'offerSummary',
            params: { offerId },
          });

          return false;
        },
      },
      {
        priority: -1,
        regex: HANDLING_ITEM_SCAN_PATTERN,
        handler: (value: string) => {
          const [, itemId = ''] = value.match(HANDLING_ITEM_SCAN_PATTERN) || [];

          router.push({
            name: 'handlingItemDetails',
            params: { handlingItemId: itemId },
          });

          return false;
        },
      },
    ],
    true,
  );
};
